export default "__VITE_ASSET__ti8o_aHk__"